import axios from "axios";
import Select from "react-select";
import config from "../../../config/config";

import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { uploadAWS } from "../../../common/AWSHelper";
import Loader from "../../../components/Loader/Loader";
import { AWS_IMAGE_FOLDER_RECEIVING } from "../../../common/Constant";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_CUSTOMER,
  AWS_IMAGE_FOLDER_WORKORDERS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import moment from "moment";
import ClearDataPayBill from "../../../components/Modal/ClearDataPayBill";
import { Modal } from "bootstrap";

const PayBills = () => {
  let navigate = useNavigate();
  const paramObject = useParams();
  const buttonRef = useRef(null);
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const locationId = localStorage.getItem("Location");
  const [loading, setLoading] = useState(false);
  const [todayDate, setTodayDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [amountReceived, setAmountReceived] = useState(0);
  const [FileUrl, setFileUrl] = useState("");
  const [btnFileLoader, setBtnFileLoader] = useState({ Receipt: false });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(100);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [supplier, setSupplier] = useState([]);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [accountId, setAccountId] = useState("");
  const [sortingId, setSortingId] = useState(6);
  const [refrenceno, setRefrenceNo] = useState(0);
  const [selectedSupplier, setSelectedSupplier] = useState(0);
  const [oldSelectedSupplier, setOldSelectedSupplier] = useState(0);
  const [showPopupForWarning, setShowPopupForWarning] = useState(false);
  const [selectedRows, setSelectedRows] = useState("");
  const [value, setValue] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [formValues, setFormValues] = useState([]);
  let lengthOfFormValue = new Array(formValues?.length).fill(false);
  const [creditValidation, setCreditValidation] = useState([]);
  const [paymentValidation, setPaymentValidation] = useState([]);

  const [firstLoad, setFirstLoad] = useState(true);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [showBillRedirectModal, setShowBillRedirectModal] = useState(false);
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [redirectReceivingID, setRedirectReceivingID] = useState(false);
  const [answer1, setAnswer1] = useState(false);
  const [selectSupplierPassingEvent, setSelectSupplierPassingEvent] =
    useState();
  const [totalChecked, setTotalChecked] = useState(0);
  const [totalOpenBalance, setTotalOpenBalance] = useState(0);
  const [totalCreditValue, setTotalCreditValue] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [totalFinalAmount, setTotalFinalAmount] = useState(0);

  const [startOldDate, setStartOldDate] = useState("");
  const [endOldDate, setEndOldDate] = useState("");
  const [OldCustomDate, setOldCustomDate] = useState(0);

  const [beginningDate, setBeginningDate] = useState("");
  const [finalDate, setFinalDate] = useState("");
  const [customeDate, setCustomDate] = useState(0);
  const [payBillData, setPayBillData] = useState([]);

  const [creditValidationMessage, setCreditValidationMessage] = useState("");

  const dateOptions = [
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
    { label: "Select", value: 0 },
  ];

  console.log(customeDate, OldCustomDate, "customeDate");
  //Date

  console.log(formValues, "formValues");
  //Today
  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  const handleDateFilter = (event) => {
    setShowDateFilterModal(true);
    setOldCustomDate(customeDate);
    console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == null) {
      setBeginningDate("");
      setFinalDate("");
      setCustomDate();
    }
  };

  //Date
  const handleDate = (event) => {
    setStartOldDate(beginningDate);
    // console.log(beginningDate, "From:")
    console.log(event?.target?.value, "eventisss92");
    setBeginningDate(event?.target?.value);
    setCustomDate(7);
    setShowDateFilterModal(true);
  };

  const handleEndDate = (event) => {
    setEndOldDate(finalDate);
    setFinalDate(event?.target?.value);
    setCustomDate(7);
    setShowDateFilterModal(true);
  };

  console.log(startOldDate, endOldDate, "old date check");

  useEffect(() => {
    setCreditValidation(creditValidation);
    setTotalChecked(formValues.filter((item) => item.Checked == true).length);
    setTotalOpenBalance(
      formValues
        .filter((item) => item.Checked == true)
        .reduce((acc, cur) => {
          acc += +(cur.OPENBALANCE == undefined ? 0 : cur.OPENBALANCE);
          return acc;
        }, 0)
    );
    setTotalPayment(
      formValues
        .filter((item) => item.Checked == true)
        .reduce((acc, cur) => {
          acc += +(cur.PAYMENT == undefined ? 0 : cur.PAYMENT);
          return acc;
        }, 0)
    );
    setTotalCreditValue(
      formValues
        .filter((item) => item.Checked == true)
        .reduce((acc, cur) => {
          acc += +(cur.CREDITAPPLIEDVALUE == undefined
            ? 0
            : cur.CREDITAPPLIEDVALUE);
          return acc;
        }, 0)
    );
  }, [formValues]);

  const totalOpenbalance = () => {
    let data = formValues?.reduce((acc, next) => {
      acc += next.OPENBALANCE;
      return acc;
    }, 0);
    return data;
  };

  // const footer = {
  //   OPENBALANCE: totalOpenbalance(),
  //   // CREDITAPPLIEDVALUE: "Demo 3",
  //   // PAYMENT: "Demo 2",
  //   // "TOTAL AMOUNT": "Demo 1"
  // };

  const customFooter = (data) => {
    const total = data?.reduce((sum, item) => sum + item.OPENBALANCE, 0);
    return <div>Total: {total}</div>;
  };

  console.log(creditValidation, "creditValidation");
  //For persisting the data
  // const history = createBrowserHistory();

  // const [creditAppliedValue, setCreditAppliedValue] = useState(0);
  const [creditAppliedValue, setCreditAppliedValue] = useState([
    {
      receivingid: 0,
      supplierid: 0,
      value: 0,
    },
  ]);
  const [creditAppliedInputBox, setCreditAppliedInputBox] = useState(0);
  const [paymentInputBox, setPaymentInputBox] = useState(0);
  const [totalAmount, setTotalAmount] = useState();
  console.log("data 758", data);
  const [supplierCreditAppliedValue, setSupplierCreditAppliedValue] = useState(
    []
  );

  const [rowCreditTotalAmount, setRowCreditTotalAmount] = useState([]);
  const [rowPaymentTotalAmount, setRowPaymentTotalAmount] = useState([]);
  // const [formValues, setFormValues] = useState({
  //   Customer: "",
  //   DepositTo: "",
  //   ReferenceNumber: "",
  //   PaymentMethod: "",
  //   InvoiceNumber: "",
  //   Memo: "",
  // });

  const handlePageChange = (page) => {
    const answer = window.confirm(
      "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"
    );
    if (answer) {
      setCurrentPage(page);
      handleListData(
        page,
        perPageSize,
        searchtext,
        sortingId,
        sortingDirection,
        beginningDate,
        finalDate
      );
    }
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    const answer = window.confirm(
      "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"
    );

    if (answer) {
      setperPageSize(newPerPage);
      setCurrentPage(page);
      handleListData(
        page,
        newPerPage,
        searchtext,
        sortingId,
        sortingDirection,
        beginningDate,
        finalDate
      );
    }
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      beginningDate,
      finalDate
    );
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(
      1,
      perPageSize,
      e.target.value,
      sortingId,
      sortingDirection,
      beginningDate,
      finalDate
    );
  };

  //Checkbox
  const handleCheckboxChange = (event, index) => {
    console.log("eventtttt", event);
    // console.log("event.target?.allSelected",event.target?.allSelected);
    setSelectedRows(event.selectedRows);
  };
  console.log("SelectedRows", selectedRows);
  console.log("supplierCreditAppliedValue336", supplierCreditAppliedValue);

  //Filter Supplier Id Credit

  // const filterCreditSupplierID = data.filter((el) => {
  //   // el.ReceivingID === rowPaymentTotalAmount.receivingID;
  //   console.log(el.ReceivingID, "data babujij");
  //   console.log(rowCreditTotalAmount.receivingID, "aaaaaaaaaaaaaabb");
  // });
  // console.log("filterrrrrrrrr", filterCreditSupplierID);
  // const filterPaymentSupplierID = data.filter((el) => {
  //   return el.ReceivingID === rowPaymentTotalAmount.receivingID;
  // });

  const filterRowCreditTotalAmount = rowCreditTotalAmount.filter(
    (e) => e?.isChecked === true
  );
  //Total Payment

  // console.log(formValues,"formValues")

  const total = formValues?.reduce((acc, curr) => {
    acc =
      acc +
      // (Number(parseFloat(curr?.CREDITAPPLIEDVALUE) && curr?.Checked == true ? parseFloat(curr?.CREDITAPPLIEDVALUE) : 0)) +
      Number(
        parseFloat(curr?.PAYMENT) && curr?.Checked == true
          ? parseFloat(curr?.PAYMENT)
          : 0
      );
    return acc;
  }, 0);

  console.log(total, "total");

  //Total when there is a payBill id

  const paymentTotal = payBillData?.reduce((acc, curr) => {
    acc += Number(
      parseFloat(curr?.PaymentAmount) ? parseFloat(curr?.PaymentAmount) : 0
    );
    return acc;
  }, 0);

  console.log(paymentTotal, "paymentTotal");

  console.log(payBillData, "payBillData417");

  //Overall Total payment and credit

  const editTotal = payBillData?.reduce((acc, curr) => {
    acc += Number(curr.CreditApplied) + Number(curr.PaymentAmount);
    return acc;
  }, 0);

  console.log(editTotal, "editTotal389");
  //handleChangeInput
  const handleInputChange = (event, index, fieldName) => {
    console.log(event, index, fieldName, "382");
    if (fieldName == "CreditApplied") {
      const updatedData = [...payBillData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };
      setPayBillData(updatedData);
    } else if (fieldName == "PaymentAmount") {
      const updatedData = [...payBillData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };
      setPayBillData(updatedData);
    } else if (fieldName == "RefNo") {
      const updatedData = [...payBillData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };
      setPayBillData(updatedData);
    } else if (fieldName === "PaymentTypeId") {
      const updatedData = [...payBillData];
      updatedData[0] = {
        ...updatedData[index],
        [fieldName]: parseInt(event.target.value),
      };
      setPayBillData(updatedData);
    }
  };

  // Styles
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  const selectStylesForPaymentMethod = {
    // dropdown input css
    // control: (provided, state) => ({
    //   ...provided,
    //   width: "100%",
    //   height: "40px",
    //   position: "relative",
    //   border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
    //   boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
    //   "&:hover": {
    //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
    //   },
    // }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    // option: (provided, state) => ({
    //   ...provided,
    //   backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
    //   "&:hover": {
    //     backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
    //   },
    // }),
  };
  let supplierTypeDropdownOption = [];
  const termpsupplierlist = supplier.filter((u, i) => {
    // if (u.ID != 0) {
    supplierTypeDropdownOption[i] = {
      // label:u.FirstName,
      label: u.CompanyName + " (" + (u.FirstName + " " + u.LastName) + ")",
      value: u.ID,
    };
    // }
  });

  console.log(supplierTypeDropdownOption, "supplierTypeDropdownOption");

  // selectedSupplier != 0 ? (

  //   supplier.filter((u, i) => {

  //     if( u.ID != 0){
  //       supplierTypeDropdownOption[i] = {
  //         label: u.FirstName,
  //         value: u.ID,
  //       }
  //       }
  //     })
  //     ) : (
  //   supplier.filter((u, i) => {

  //     if( u.ID != 0){
  //       supplierTypeDropdownOption[i] = {
  //         label: u.FirstName,
  //         value: u.ID,
  //       }
  //       }
  //     })
  // )

  console.log(supplierTypeDropdownOption, "supplierTypeDropdownOption");
  // Account Type Dropdown
  let accountTypeDropdownOption = [];

  const AccountDropdown = chartOfAccountDropdown.map((u, i) => {
    accountTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      amount: u.Amount,
    };
  });

  //   Customer Drop Down
  let customerOption = [];
  const customerDropdown = customer.map((u, i) => {
    customerOption[i] = {
      label: u.FirstName + " " + u.LastName,
      value: u.Id,
    };
  });

  //   Payment Method Drop Down
  let paymentMethodOption = [];
  const payementDropdown = paymentMethod.map((u, i) => {
    paymentMethodOption[i] = {
      label: u.Paymenttypename,
      value: u.ID,
    };
  });

  let paymentMethodOptionForStoreAccount = [];
  const payementDropgdown1 = paymentMethod.filter((u, i) => {
    return u.ID != 6
      ? (paymentMethodOptionForStoreAccount[i] = {
          label: u.Paymenttypename,
          value: u.ID,
        })
      : "";
  });

  // console.log(payementDropgdown1, "paymentMethod");
  // console.log(paymentMethodOptionForStoreAccount, "paymentMethod");

  // const handleChangeCheckbox = (e, row) => {
  //   // setValue(e.target.checked);
  //   console.log("eiiiiiiii 445566", e.target.checked, row);

  //   console.log("row.ReceivingID ==> 445566 ", row.ReceivingID);

  //   // Filter data in CreditApplied Amount
  //   // let creditAppliedAmountObject = rowCreditTotalAmount.filter(
  //   //   (e) => e?.receivingID === row.ReceivingID
  //   // );

  //   //find Index in Credit
  //   const creditAppliedAmountObjectIndex = rowCreditTotalAmount.findIndex(
  //     (e) => e?.receivingID === row.ReceivingID
  //   );

  //   console.log(
  //     "creditAppliedAmountObjectIndex",
  //     creditAppliedAmountObjectIndex
  //   );
  //   //Filter data in PaymentApplied Amount
  //   // let paymentAmountObject = rowPaymentTotalAmount.filter(
  //   //   (e) => e?.receivingID === row.ReceivingID
  //   // );

  //   //find Index in Payment
  //   const paymentAmountObjectIndex = rowPaymentTotalAmount.findIndex(
  //     (e) => e.receivingID == row.ReceivingID
  //   );
  //   console.log("paymentAmountObjectIndex", paymentAmountObjectIndex);

  //   console.log("rowPaymentTotalAmount 259 ==> ", rowPaymentTotalAmount);
  //   console.log("rowCreditTotalAmount 260 ==> ", rowCreditTotalAmount);

  //   if (creditAppliedAmountObjectIndex != -1) {
  //     // creditAppliedAmountObject.isChecked = e.target.checked;

  //     const creditAppliedAmountObject =
  //       rowCreditTotalAmount[creditAppliedAmountObjectIndex];
  //     creditAppliedAmountObject.isChecked = e.target.checked;

  //     const updatedcreditAppliedAmountObject = [...rowCreditTotalAmount];
  //     updatedcreditAppliedAmountObject[creditAppliedAmountObjectIndex] =
  //       creditAppliedAmountObject;
  //     setRowCreditTotalAmount(updatedcreditAppliedAmountObject);
  //   }

  //   if (paymentAmountObjectIndex != -1) {
  //     // paymentAmountObject.isChecked = e.target.checked;

  //     const paymentAmountObject =
  //       rowPaymentTotalAmount[paymentAmountObjectIndex];
  //     paymentAmountObject.isChecked = e.target.checked;

  //     const updatedpaymentAmountObject = [...rowPaymentTotalAmount];
  //     updatedpaymentAmountObject[paymentAmountObjectIndex] =
  //       paymentAmountObject;
  //     setRowPaymentTotalAmount(updatedpaymentAmountObject);
  //   }

  //   // console.log("rowCreditTotalAmount 288==>", rowCreditTotalAmount);
  //   // console.log("rowPaymentTotalAmount 289==>", rowPaymentTotalAmount);
  //   // let creditAppliedAmount = creditAppliedAmountObject
  //   //   ? creditAppliedAmountObject?.creditApplied
  //   //   : 0;

  //   // let paymentAmount = paymentAmountObject ? paymentAmountObject?.payment : 0;

  //   // let rowWiseTotalAmount =
  //   //   parseFloat(creditAppliedAmount) + parseFloat(paymentAmount);
  // };

  //h
  // Outstanding Table Column

  // const handleChangeCheckbox = (e,index) => {
  //   setFormValues((formData) => {
  //     return formData.map((item, i) => {
  //       if (i === index) {
  //         return { ...item, Checked: !item.Checked };
  //       } else {
  //         return item;
  //       }
  //     });
  //   });
  // };
  let outstandingColumns;

  console.log("supplier 595", supplier);
  if (paramObject.id > 0) {
    outstandingColumns = [
      // {
      //   name: "Sr.No.",
      //   selector: (row, index) => index + 1,
      //   sortable: true,
      //   width: "100px",
      // },
      {
        name: "PAYEE",
        selector: (row) => {
          const payee = supplier.find((el) => el && el.ID === row?.PayeeID);
          console.log("row, payee", row, payee);
          return payee ? payee.FirstName : "";
        },
        sortable: true,
      },
      {
        name: "BILL NO.",
        selector: (row) => row["BillNo"],
        sortable: true,
        width: "180px",
      },
      {
        name: "DUE DATE",
        selector: (row) => moment(row["DueDate"]).format("DD-MM-YYYY"),
        sortable: true,
        width: "180px",
      },
      {
        name: "OPEN BALANCE",
        // selector: (row) => parseFloat(row["OPENBALANCE"]).toFixed(2),
        cell: (row) => {
          return (
            <div>
              <div>{parseFloat(row["OPENBALANCE"]).toFixed(2)}</div>
              {row.BILLTYPE}
            </div>
          );
        },
        sortable: true,
        width: "180px",
        right: true,
      },
      // {
      //   name: "CREDIT APPLIED",
      //   selector: (row) => row["CREDITAPPLIED"],
      //   // selector: (row) =>
      //   //   row?.CreditApplied ? parseFloat(row?.CreditApplied).toFixed(2) : 0.0,
      //   sortable: true,
      //   width: "180px",
      //   right: true,
      //   cell: (row, index) => {
      //     return (
      //       <div>
      //         <input
      //           className="form-control form-control-sm mt-1 mb-1"
      //           type="number"
      //           name="CREDITAPPLIEDVALUE"
      //           id="CREDITAPPLIEDVALUE"
      //           // min={0}
      //           value={
      //             // payBillData?.find((el) => el?.ReceivingId == row?.ReceivingId)
      //             //   ?.CreditApplied
      //             Math.abs(payBillData[0]?.CreditApplied)
      //           }
      //           onChange={(event) => {
      //             handleInputChange(event, index, "CreditApplied")
      //             handleCellChange(event, row, index);
      //           }}
      //         />

      //         {creditValidation[index] && (
      //           <p className="text-danger mb-0">
      //             Value must not exceed{" "}
      //             {parseInt(payBillData[0]?.OPENBALANCE)}
      //           </p>
      //         )}
      //         {
      //           // (paramObject.id > 0) ?
      //           (
      //             <div>
      //               {supplierCreditAppliedValue.find(
      //                 (item) => item.supplierid === row.SupplierId
      //               )
      //                 ? supplierCreditAppliedValue.find(
      //                   (item) => item.supplierid === row.SupplierId
      //                 )?.CustomerBalance :
      //                 parseFloat(payBillData[0]?.CustomerBalance).toFixed(2) + " Available"}
      //             </div>
      //           )
      //           // : (
      //           //   <div style={{ color: "#6b6c72" }}>
      //           //     {supplierCreditAppliedValue.find(
      //           //       (item) => item.supplierid === row.SupplierID
      //           //     )
      //           //       ? supplierCreditAppliedValue.find(
      //           //         (item) => item.supplierid === row.SupplierID
      //           //       )?.availableAmount
      //           //       : parseFloat(row.CREDITAPPLIED).toFixed(2)}{" "}
      //           //     Available
      //           //   </div>
      //           // )
      //         }

      //       </div>
      //     )
      //   }
      // },
      {
        name: "CREDIT APPLIED",
        selector: (row) => row["CREDITAPPLIED"],
        width: "200px",
        sortable: true,
        cell: (row, index) => {
          if (row?.CREDITAPPLIED > 0) {
            return (
              <div>
                {/* {console.log("row.id", row.ReceivingID)} */}
                <input
                  className="form-control form-control-sm mt-3 mb-1"
                  type="number"
                  name="CREDITAPPLIEDVALUE"
                  id="CREDITAPPLIEDVALUE"
                  // min={0}
                  value={
                    formValues.find((el) => el?.ReceivingID == row?.ReceivingID)
                      ?.CREDITAPPLIEDVALUE
                  }
                  // onChange={(event) => handleCellChange(event, index)}
                  // onChange={(event) => handleCellChange(event, row, index)}
                  onChange={(event) => {
                    handleChangeInput(event, index, "CREDITAPPLIEDVALUE", row);
                    handleCellChange(event, row, index);
                  }}
                />

                {/* {creditValidation[index]}457 */}
                {creditValidation[index] && (
                  <p className="text-danger mb-0">
                    {/* Value must not exceed{" "}
                    {parseInt(formValues[index]?.OPENBALANCE)} */}

                    {creditValidationMessage}
                  </p>
                )}
                <div style={{ color: "#6b6c72" }}>
                  {supplierCreditAppliedValue.find(
                    (item) => item.supplierid === row?.SupplierID
                  )
                    ? supplierCreditAppliedValue.find(
                        (item) => item.supplierid === row?.SupplierID
                      )?.availableAmount
                    : parseFloat(row?.CREDITAPPLIED).toFixed(2)}{" "}
                  Available
                  {/* {supplierCreditAppliedValue.find(
                   (item) => item.supplierid === row.SupplierID
                 )?.availableAmount > 0
                   ? supplierCreditAppliedValue.find(
                       (item) => item.supplierid === row.SupplierID
                     )?.availableAmount
                   : parseFloat(row.CREDITAPPLIED).toFixed(2)
                   }{" "} */}
                  {/* Available */}
                  <>
                    {/* {
                     supplierCreditAppliedValue.find(
                       (item) => item.supplierid === row.SupplierID
                     )?.availableAmount
                   } */}
                  </>
                  {/* <br></br>
                 {isNaN(creditAppliedValue.availableAmount)
                   ? row.CREDITAPPLIED
                   : creditAppliedValue.availableAmount}{" "}
                 Available */}
                </div>
              </div>
            );
          } else {
            return <div style={{ color: "#6b6c72" }}>Not Available</div>;
          }
        },
      },
      // {
      //   name: "PAYMENT",
      //   // selector: (row) => parseFloat(row["PaymentAmount"]).toFixed(2),
      //   sortable: true,
      //   width: "180px",
      //   right: true,
      //   cell: (row, index) => (
      //     <div>
      //       <input
      //         className="form-control form-control-sm mb-1"
      //         type="number"
      //         name="PAYMENT"
      //         id="PAYMENT"
      //         // value={payBillData?.find((el) => el?.ReceivingId == row?.ReceivingId)
      //         //   ?.PaymentAmount}
      //         value={Number(payBillData[0]?.PaymentAmount)}
      //         onChange={(event) => {
      //           handleInputChange(event, index, "PaymentAmount")
      //         }}
      //       />
      //     </div>
      //   ),
      // },
      {
        name: "PAYMENT",
        width: "150px",
        sortable: true,
        cell: (row, index) => (
          <input
            className="form-control form-control-sm mt-1 mb-1"
            type="number"
            name="PAYMENT"
            id="PAYMENT"
            value={formValues[index]?.PAYMENT}
            onChange={(event) => {
              handleChangeInput(event, index, "PAYMENT", row);
            }}
            // onChange={(event) => handleChangePayment(event, index)}
          />
        ),
      },
      // {
      //   name: "PAYMENT METHOD",
      //   width: "200px",
      //   cell: (row, index) => (
      //     <>
      //       <select
      //         id="PaymentMethod"
      //         name="PaymentMethod"
      //         className="form-select form-select-sm"
      //         onChange={(event) =>
      //           handleInputChange(event, index, "PaymentTypeId")
      //         }
      //       >
      //         {paymentMethodOptionForStoreAccount?.map((e) => {
      //           return (
      //             <option value={e?.value == row.PaymentTypeId}>
      //               {e?.label}
      //             </option>
      //           );
      //         })}
      //       </select>
      //     </>
      //   ),
      //   sortable: true,
      // },
      // {
      //   name: "Reference Number",
      //   // selector: (row) => row["RefNo"],
      //   sortable: true,
      //   width: "200px",
      //   cell: (row, index) => (
      //     <input
      //       className="form-control form-control-sm mt-1 mb-1"
      //       type="text"
      //       name="RefrenceNumber"
      //       id="RefrenceNumber"
      //       onChange={(event) => {
      //         handleInputChange(event, index, "RefNo");
      //       }}
      //     />
      //   ),
      // },
      // {
      //   name: "TOTAL AMOUNT",
      //   // selector: (row) => Number(row["Total"]).toFixed(2),
      //   sortable: true,
      //   width: "180px",
      //   right: true,
      //   cell: () => {
      //     return (
      //       <div>{editTotal ? editTotal : 0}</div>
      //     )
      //   }
      // },
      {
        name: "PAYMENT METHOD",
        // selector: "ID",
        width: "200px",
        cell: (row, index) => (
          <>
            <select
              id="PaymentMethod"
              name="PaymentMethod"
              className="form-select form-select-sm"
              onChange={(event) =>
                handleChangeInput(event, index, "PaymentMethod", row)
              }
              value={formValues[index]?.PaymentMethod}
            >
              {formValues[index]?.PAYMENT > 0
                ? paymentMethodOptionForStoreAccount?.map((e) => {
                    return <option value={e?.value}>{e?.label}</option>;
                  })
                : paymentMethodOption?.map((e) => {
                    return <option value={e?.value}>{e?.label}</option>;
                  })}
            </select>

            {/* <Select
             options={paymentMethodOption}
             placeholder="Payment Method"
             backspaceRemovesValue={false}
             controlShouldRenderValue={true}
             hideSelectedOptions={true}
             isClearable={true}
             // // style={{
             // //   position: "absolute",
             // //   "z-index": "999",
             // //   background: "#f8f8f8",
             // //   width: "100%",
             // // }}
             // id="PaymentMethod"
             name="PaymentMethod"
             onChange={(event) =>
               handleChangeInput(event, index, "PaymentMethod", row)
             }
           // onChange={(e) => handleChangePayment(e, index, "PaymentMethod", row)}
           /> */}
          </>
        ),
        sortable: true,
      },
      {
        name: "Refrence Number",
        width: "200px",
        sortable: true,
        cell: (row, index) => (
          <input
            className="form-control form-control-sm mt-1 mb-1"
            type="text"
            name="RefrenceNumber"
            id="RefrenceNumber"
            onChange={(event) => {
              handleChangeInput(event, index, "RefrenceNumber", row);
            }}
            value={formValues[index]?.RefrenceNumber}
          />
        ),
      },
      {
        name: "TOTAL AMOUNT",
        width: "200px",
        sortable: true,
        selector: "TOTAL AMOUNT",
        cell: (row, index) => (
          <>
            {/* {console.log("aaaaaaaaaaaaaaaaaaaaaa", rowPaymentTotalAmount)} */}
            {/* <div>{rowTotalAmount[index]?.totalAmount || 0}</div>
           <div>{console.log("aaaaaaaaaaa=...", rowTotalAmount)}</div> */}
            <div>
              {/* {parseFloat(row.PAYMENT ? row.PAYMENT : 0) +
               parseFloat(row.CREDITAPPLIEDVALUE ? row.CREDITAPPLIEDVALUE : 0)} */}
              {/* {(parseFloat(rowPaymentTotalAmount[index]?.payment)
               ? parseFloat(rowPaymentTotalAmount[index]?.payment)
               : 0) +
               (parseFloat(rowCreditTotalAmount[index]?.creditApplied)
                 ? parseFloat(rowCreditTotalAmount[index]?.creditApplied)
                 : 0)} */}
              {(parseFloat(formValues[index]?.CREDITAPPLIEDVALUE)
                ? parseFloat(formValues[index]?.CREDITAPPLIEDVALUE)
                : 0) +
                (parseFloat(formValues[index]?.PAYMENT)
                  ? parseFloat(formValues[index]?.PAYMENT)
                  : 0)}
            </div>

            {/* <span>{rowTotalAmount.map((e, i) => e.totalAmount[i])}</span> */}
          </>
        ),
      },
    ];
  } else {
    outstandingColumns = [
      {
        name: "",
        // selector: (row, index) => ,
        sortable: false,
        width: "60px",
        cell: (row, index) => {
          return (
            <>
              <input
                type="checkbox"
                name="Checked"
                checked={formValues[index]?.Checked}
                onChange={(event) =>
                  handleChangeInput(event, index, "Checked", row)
                }
              />
            </>
          );
        },
      },
      // {
      //   name: "Sr.No.",
      //   selector: (row, index) => index + 1,
      //   sortable: true,
      //   width: "100px",
      // },
      {
        name: "PAYEE",
        // selector: (row) => row["PAYEE"],
        selector: (row) => (
          <p className="word-break-data" title={row.PAYEE}>
            {row.PAYEE}
          </p>
        ),
        sortable: true,
      },
      {
        name: "BILL NO.",
        // selector: (row) => row["REFNO"],
        sortable: true,
        width: "140px",
        cell: (row, index) => {
          return (
            <div>
              <p
                style={{ cursor: "pointer" }}
                onClick={() => NavigateToRecBill(row.ReceivingID)}
              >
                {row.REFNO}
              </p>
            </div>
          );
        },
      },
      {
        name: "DUE DATE",
        selector: (row) =>
          row["DUEDATE"] != null ? (
            <>
              {moment(row["DUEDATE"]).isBefore(moment()) ? (
                <>
                  {moment(row["DUEDATE"]).format("DD-MM-YYYY") + "  "}
                  <i class="fa fa-circle" style={{ color: "red" }}></i>
                </>
              ) : (
                moment(row["DUEDATE"]).format("DD-MM-YYYY")
              )}
            </>
          ) : (
            ""
          ),
        sortable: true,
        width: "140px",
      },
      {
        name: "OPEN BALANCE",
        selector: (row) => parseFloat(row["OPENBALANCE"]).toFixed(2),
        cell: (row) => {
          return (
            <div>
              <div>{parseFloat(row["OPENBALANCE"]).toFixed(2)}</div>
              {row.BILLTYPE}
            </div>
          );
        },
        width: "180px",
        sortable: true,
        footer: customFooter(),
      },
      {
        name: "CREDIT APPLIED",
        selector: (row) => row["CREDITAPPLIED"],
        width: "200px",
        sortable: true,
        cell: (row, index) => {
          if (row.CREDITAPPLIED > 0) {
            return (
              <div>
                {/* {console.log("row.id", row.ReceivingID)} */}

                <input
                  className="form-control form-control-sm mt-3 mb-1"
                  type="number"
                  name="CREDITAPPLIEDVALUE"
                  id="CREDITAPPLIEDVALUE"
                  min={0}
                  value={
                    formValues.find((el) => el?.ReceivingID == row?.ReceivingID)
                      ?.CREDITAPPLIEDVALUE
                  }
                  // onChange={(event) => handleCellChange(event, index)}
                  // onChange={(event) => handleCellChange(event, row, index)}
                  onChange={(event) => {
                    handleChangeInput(event, index, "CREDITAPPLIEDVALUE", row);
                    handleCellChange(event, row, index);
                  }}
                />

                {creditValidation[index] && (
                  <p className="text-danger mb-0">
                    {creditValidationMessage}

                    {/* below code comment on 14/10/2023 for showing message both column Credit Applied and Open Balance. and message logic added in the function */}
                    {/* Value must not exceed{" "}
                    {Number(formValues[index]?.CREDITAPPLIED)} */}
                  </p>
                )}
                <div style={{ color: "#6b6c72" }}>
                  {supplierCreditAppliedValue.find(
                    (item) => item.supplierid === row.SupplierID
                  )
                    ? supplierCreditAppliedValue.find(
                        (item) => item.supplierid === row.SupplierID
                      )?.availableAmount
                    : parseFloat(row.CREDITAPPLIED).toFixed(2)}{" "}
                  Available
                  {/* {supplierCreditAppliedValue.find(
                   (item) => item.supplierid === row.SupplierID
                 )?.availableAmount > 0
                   ? supplierCreditAppliedValue.find(
                       (item) => item.supplierid === row.SupplierID
                     )?.availableAmount
                   : parseFloat(row.CREDITAPPLIED).toFixed(2)
                   }{" "} */}
                  {/* Available */}
                  <>
                    {/* {
                     supplierCreditAppliedValue.find(
                       (item) => item.supplierid === row.SupplierID
                     )?.availableAmount
                   } */}
                  </>
                  {/* <br></br>
                 {isNaN(creditAppliedValue.availableAmount)
                   ? row.CREDITAPPLIED
                   : creditAppliedValue.availableAmount}{" "}
                 Available */}
                </div>
              </div>
            );
          } else {
            return <div style={{ color: "#6b6c72" }}>Not Available</div>;
          }
        },
      },
      {
        name: "PAYMENT",
        width: "150px",
        sortable: true,
        cell: (row, index) => (
          <div>
            <input
              className="form-control form-control-sm mt-1 mb-1"
              type="number"
              name="PAYMENT"
              id="PAYMENT"
              value={formValues[index]?.PAYMENT}
              onChange={(event) => {
                handleChangeInput(event, index, "PAYMENT", row);
              }}
              // onChange={(event) => handleChangePayment(event, index)}
            />
            {paymentValidation[index] && (
              <p className="text-danger mb-0">payment limit reached</p>
            )}
          </div>
        ),
      },
      {
        name: "PAYMENT METHOD",
        // selector: "ID",
        width: "200px",
        cell: (row, index) => (
          <>
            <select
              id="PaymentMethod"
              name="PaymentMethod"
              className="form-select form-select-sm"
              onChange={(event) =>
                handleChangeInput(event, index, "PaymentMethod", row)
              }
            >
              {formValues[index]?.PAYMENT > 0
                ? paymentMethodOptionForStoreAccount?.map((e) => {
                    return <option value={e?.value}>{e?.label}</option>;
                  })
                : paymentMethodOption?.map((e) => {
                    return <option value={e?.value}>{e?.label}</option>;
                  })}
            </select>

            {/* <Select
             options={paymentMethodOption}
             placeholder="Payment Method"
             backspaceRemovesValue={false}
             controlShouldRenderValue={true}
             hideSelectedOptions={true}
             isClearable={true}
             // // style={{
             // //   position: "absolute",
             // //   "z-index": "999",
             // //   background: "#f8f8f8",
             // //   width: "100%",
             // // }}
             // id="PaymentMethod"
             name="PaymentMethod"
             onChange={(event) =>
               handleChangeInput(event, index, "PaymentMethod", row)
             }
           // onChange={(e) => handleChangePayment(e, index, "PaymentMethod", row)}
           /> */}
          </>
        ),
        sortable: true,
      },
      {
        name: "Refrence Number",
        width: "200px",
        sortable: true,
        cell: (row, index) => (
          <input
            className="form-control form-control-sm mt-1 mb-1"
            type="text"
            name="RefrenceNumber"
            id="RefrenceNumber"
            onChange={(event) => {
              handleChangeInput(event, index, "RefrenceNumber", row);
            }}
          />
        ),
      },
      {
        name: "TOTAL AMOUNT",
        width: "200px",
        sortable: true,
        selector: "TOTAL AMOUNT",
        cell: (row, index) => (
          <>
            {/* {console.log("aaaaaaaaaaaaaaaaaaaaaa", rowPaymentTotalAmount)} */}
            {/* <div>{rowTotalAmount[index]?.totalAmount || 0}</div>
           <div>{console.log("aaaaaaaaaaa=...", rowTotalAmount)}</div> */}
            <div>
              {/* {parseFloat(row.PAYMENT ? row.PAYMENT : 0) +
               parseFloat(row.CREDITAPPLIEDVALUE ? row.CREDITAPPLIEDVALUE : 0)} */}
              {/* {(parseFloat(rowPaymentTotalAmount[index]?.payment)
               ? parseFloat(rowPaymentTotalAmount[index]?.payment)
               : 0) +
               (parseFloat(rowCreditTotalAmount[index]?.creditApplied)
                 ? parseFloat(rowCreditTotalAmount[index]?.creditApplied)
                 : 0)} */}
              {(parseFloat(formValues[index]?.CREDITAPPLIEDVALUE)
                ? parseFloat(formValues[index]?.CREDITAPPLIEDVALUE)
                : 0) +
                (parseFloat(formValues[index]?.PAYMENT)
                  ? parseFloat(formValues[index]?.PAYMENT)
                  : 0)}
            </div>

            {/* <span>{rowTotalAmount.map((e, i) => e.totalAmount[i])}</span> */}
          </>
        ),
      },
    ];
  }

  // Validation for the file upload
  const vaidation = (name, value) => {
    switch (name) {
      case "Attachment":
        if (!value.name.match(/\.(jpg|jpeg|png|pdf|heic)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  console.log(payBillData, "payBillData");
  const handleConfirmationSubmit = () => {
    if (balanceAmount !== 0) {
      if (total <= 0 && paramObject.id == undefined) {
        toastError("Please fill the Payment");
        return;
      }
      if (balanceAmount - total < 0) {
        const modalElement = document.getElementById("FundModal");
        const modal = Modal.getOrCreateInstance(modalElement);
        modal.show();
      } else {
        handleSubmit();
      }
    } else {
      toastError("Please select account first");
      return;
    }
  };

  // Upload function for uploading the file on AWS
  const uploadFilePDF = async (file, type, index) => {
    setBtnFileLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_RECEIVING, (data) => {
      if (data) {
        if (type === "Attachment") {
          setFileUrl(data);
          setLoading(false);
        }
      }
    });
  };

  // Handle the for the file change
  const handleFileChange = (event, index) => {
    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
      // console.log(event.currentTarget.files[0]);
      uploadFilePDF(event?.currentTarget?.files[0], event.target.name, index);
    }

    const files = event.target.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };

  const SupplierAPI = () => {
    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        // console.log("response", response.data.ResponseData);

        setSupplier([
          { FirstName: "Select Supplier", ID: 0 },
          ...response.data.ResponseData,
        ]);
        // setSupOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  console.log(supplier, "supplier1387");

  // Payment Method Drop Down Binding API CALL
  const PaymentMethodAPI = () => {
    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })

      .then((res) => {
        setLoading(true);
        setPaymentMethod(res.data.ResponseData);
        setLoading(false);
      });
  };
  console.log(balanceAmount, "balanceAmount");
  // Customer Drop Down Binding API CALL
  const CustomerAPI = () => {
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(true);
        setCustomer(res.data.ResponseData);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const AccountAPI = () => {
    // chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl?type=3`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("ChartOfAccountDropdown", res.data.ResponseData);
        setChartOfAccountDropdown(res.data.ResponseData);
        // setLoading(false);
        // localStorage.setItem("441-", JSON.stringify(res.data.ResponseData));
        // return res;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log("chartOfAccountDropdown 1076", chartOfAccountDropdown);

  // Handle the cancel to redirect it to sales list
  const handleCancel = () => {
    navigate("/receiving");
  };

  const handleCancelRedirect = () => {
    setShowBillRedirectModal(false);
    setRedirectReceivingID(0);
  };

  const handleConfirmRedirect = () => {
    setShowBillRedirectModal(false);
    navigate(`/manage-receiving/${redirectReceivingID}`);
  };

  // useEffect(()=>{

  //   if(beginningDate!==""){
  //     setShowDateFilterModal(true);
  //   }else if(finalDate !==""){
  //     setShowDateFilterModal(true);
  //   }

  //   if(startOldDate == beginningDate || finalDate == endOldDate){
  //     return
  //   }

  // }, [beginningDate, finalDate])

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
    setBeginningDate(startOldDate);
    setFinalDate(endOldDate);
    setCustomDate(OldCustomDate);
  };

  const handleDateFilterConfirm = () => {
    setShowDateFilterModal(false);
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      selectedSupplier,
      refrenceno,
      beginningDate,
      finalDate
    );
  };

  const NavigateToRecBill = (ReceivingID) => {
    console.log("clicked", ReceivingID);
    setShowBillRedirectModal(true);
    setRedirectReceivingID(ReceivingID);
  };

  const handleUpdateCreditApplied = (newValue, supplierID, receivingID) => {
    console.log(newValue, supplierID, receivingID, "handleUpdateCreditApplied");
    const existingItemIndex = creditAppliedValue.findIndex(
      (item) =>
        item.supplierid === supplierID && item.receivingid === receivingID
    );
    console.log("existingItemIndex ===>", existingItemIndex);
    if (existingItemIndex !== -1) {
      const existingItem = creditAppliedValue[existingItemIndex];
      existingItem.value = parseFloat(newValue);
      // existingItem.availableAmount = parseFloat(availableAmount);
      const updatedDataNew = [...creditAppliedValue];
      updatedDataNew[existingItemIndex] = existingItem;
      setCreditAppliedValue(updatedDataNew);
    } else {
      setCreditAppliedValue([
        ...creditAppliedValue,
        {
          receivingid: receivingID,
          supplierid: supplierID,
          value: newValue,
          // availableAmount: availableAmount
        },
      ]);
    }

    console.log("handleUpdateCreditApplied ==>", creditAppliedValue);
  };

  // const handleChangePayment = (e, index, fieldName) => {
  //   setSupId(data[index].SupplierID);

  //   var name = "";
  //   if (fieldName == "PaymentMethod") {
  //     name = fieldName;
  //   } else {
  //     name = e?.target?.name;
  //   }

  //   var value = 0;
  //   if (fieldName == "PaymentMethod") {
  //     value = e.value;
  //   } else {
  //     var name = e?.target?.name;
  //     value = e.target.value;
  //   }

  //   const updatedData = [...data];

  //   updatedData[index] = { ...updatedData[index], [name]: value };

  //   setData(updatedData);
  // };

  const handleYes = () => {
    console.log("call result answer");
    setAnswer1(true);
  };
  // const handleNo = () => {
  //   console.log("call result answer 1")
  //   // setAnswer1(false);
  // };

  useEffect(() => {
    console.log(answer1, "return from popup under function answer");
    if (!answer1) {
      console.log("selectedSupplier", selectedSupplier);
      console.log(answer1, "answer");
      // setOldSelectedSupplier(selectedSupplier)
      // setSelectedSupplier(2);
      // setShowPopupForWarning(false)
      setTimeout(() => {
        console.log("CALL 1 Second", oldSelectedSupplier);
        setSelectedSupplier(oldSelectedSupplier);
      }, 1000);

      return;
    } else {
      setSelectedSupplier(selectSupplierPassingEvent);
      setOldSelectedSupplier(selectSupplierPassingEvent);
      setAnswer1(false);
      setFormValues([]);
    }
  }, [answer1]);

  const selectSupplierHandle = async (event) => {
    buttonRef.current.click();
    console.log(event, "event value after click");
    // setShowPopupForWarning(true);

    // if (selectedSupplier == undefined) {
    //   setTimeout(() => {
    //     setSelectedSupplier(0);
    //     setOldSelectedSupplier(0);
    //   }, 1000);

    // }
    setSelectSupplierPassingEvent(event);

    // setShowPopupForWarning(true);
    // if (showPopupForWarning) {
    // setOldSelectedSupplier(selectedSupplier)
    // const answer = window.confirm(
    //   "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"
    // );
  };

  // const customFilterOption = (option, rawInput) => {
  //   // Return true if the option should be visible, false to hide it
  //   const inputValue = rawInput.toLowerCase();
  //   const optionLabel = option.label.toLowerCase();
  //   return optionLabel.includes(inputValue);
  // };

  // handle change for all the input fields
  const handleChangeInput = (event, index, fieldName, row) => {
    console.log(event.target.value, "766 hwefjkjkfhk ", fieldName);
    // console.log(event.target.checked, fieldName,"Checked");
    if (fieldName === "Customer") {
      console.log(event.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.value,
      }));
    } else if (fieldName === "CREDITAPPLIEDVALUE") {
      console.log(event.target.value.length, "gghhhh");

      const updatedData = [...formValues];
      if (
        (parseInt(event.target.value) <=
          // parseInt(updatedData[index].CREDITAPPLIED)  /** comment this line on 14/10/2023 for allowed credit based on OPEN BALANCE */
          parseInt(
            updatedData[index].OPENBALANCE
          ) /** add this line on 14/10/2023 for allowed credit based on OPEN BALANCE */ &&
          parseInt(event.target.value) <=
            parseInt(updatedData[index].CREDITAPPLIED)) ||
        event.target.value.length == 0
      ) {
        console.log(event.target.value.length, "gghhhh");
        const errordata = [...creditValidation];
        errordata[index] = false;
        setCreditValidation(errordata);

        const indexOfChange = updatedData.findIndex(
          (el) => el?.ReceivingID == row?.ReceivingID
        );
        console.log(indexOfChange, "indexOfChange");

        updatedData[indexOfChange] = {
          ...updatedData[indexOfChange],
          [fieldName]: Number(event.target.value),
          ["PAYMENT"]:
            Number(updatedData[indexOfChange].OPENBALANCE) -
            Number(event.target.value),
          ["Checked"]: true,
        };
        setFormValues(updatedData);
      } else {
        const errordata = [...creditValidation];
        errordata[index] = true;
        setCreditValidation(errordata);

        const indexOfChange = updatedData.findIndex(
          (el) => el?.ReceivingID == row?.ReceivingID
        );

        let ValidationMessage = "Value must not exceed ";
        if (
          event.target.value > Number(updatedData[indexOfChange]?.CREDITAPPLIED)
        ) {
          ValidationMessage =
            "Value must not exceed " +
            Number(updatedData[indexOfChange]?.CREDITAPPLIED);
        } else if (
          event.target.value > Number(updatedData[indexOfChange]?.OPENBALANCE)
        ) {
          ValidationMessage =
            "Value must not exceed " +
            Number(updatedData[indexOfChange]?.OPENBALANCE);
        }

        setCreditValidationMessage(ValidationMessage);

        updatedData[indexOfChange] = {
          ...updatedData[indexOfChange],
          [fieldName]: 0,
          ["PAYMENT"]: parseInt(updatedData[indexOfChange].OPENBALANCE), // - parseInt(event.target.value)
          ["Checked"]: true,
        };
        setFormValues(updatedData);
      }
    } else if (fieldName === "DepositTo") {
      console.log(event.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.value,
      }));
    } else if (fieldName === "RefrenceNumber") {
      // console.log(event.target.value, fieldName);
      // setFormValues((prevValues) => ({
      //   ...prevValues,
      //   [fieldName]: parseInt(event.target.value)
      // }));
      const updatedData = [...formValues];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event.target.value,
      };
      setFormValues(updatedData);
    } else if (fieldName === "PaymentMethod") {
      const updatedData = [...formValues];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: parseInt(event.target.value),
      };
      setFormValues(updatedData);
    } else if (fieldName === "InvoiceNumber") {
      console.log(event.target.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.target.value,
      }));
    } else if (fieldName === "Memo") {
      console.log(event.target.value, fieldName);
      setFormValues((prevValues) => ({
        ...prevValues,
        [fieldName]: event.target.value,
      }));
    } else if (fieldName === "PaymentDate") {
      console.log(event.target.value, fieldName);
      setTodayDate(event.target.value);
    } else if (fieldName === "AmountReceived") {
      console.log(event.target.value, fieldName);
      setAmountReceived(event.target.value);
    } else if (fieldName === "PAYMENT") {
      const updatedData = [...formValues];

      const paymentValue = Number(event.target.value);
      const openBalanceValue = Number(updatedData[index].OPENBALANCE);

      // if (paymentValue > openBalanceValue -  updatedData[index].CREDITAPPLIEDVALUE) {
      //   // Prevent further action, as user should not be able to type
      //   return;
      // }

      /** ------------------------------------------------------------------------------------------  */
      /* Comment Below code on 14/10/2023 for Allowed Extra PAYMENT amount to OPEN BALANCE  */
      // if (paymentValue > openBalanceValue - updatedData[index].CREDITAPPLIEDVALUE) {
      //   const errordata = [...paymentValidation];
      //   errordata[index] = true;
      //   setPaymentValidation(errordata)

      //   const indexOfChange = updatedData.findIndex(
      //     (el) => el?.ReceivingID === row?.ReceivingID
      //   );
      //   updatedData[indexOfChange] = {
      //     ...updatedData[indexOfChange],
      //     // ["CREDITAPPLIEDVALUE"]: openBalanceValue - paymentValue,
      //     // ["Checked"]: true,
      //     // [fieldName]: 0,
      //   };

      // }
      // // else if (paymentValue === 0) {

      // //   const errordata = [...paymentValidation];
      // //   errordata[index] = false;
      // //   setPaymentValidation(errordata)

      // //   updatedData[index] = {
      // //     ...updatedData[index],
      // //     [fieldName]: paymentValue,
      // //     ["Checked"]: false,
      // //     // ['CREDITAPPLIEDVALUE']: openBalanceValue,
      // //   };
      // // }
      // else {

      //   const errordata = [...paymentValidation];
      //   errordata[index] = false;
      //   setPaymentValidation(errordata)

      //   // if( Number(updatedData[index].CREDITAPPLIED)<=0){
      //   //   updatedData[index] = {
      //   //     ...updatedData[index],
      //   //     [fieldName]: paymentValue,
      //   //     ["Checked"]: true,
      //   //     ['CREDITAPPLIEDVALUE']: 0,
      //   //   };
      //   // }else{
      //   updatedData[index] = {
      //     ...updatedData[index],
      //     [fieldName]: paymentValue,
      //     ["Checked"]: true,
      //     // ['CREDITAPPLIEDVALUE']: openBalanceValue - paymentValue,
      //   };
      //   // }
      //   setFormValues(updatedData);
      // }

      /* END Comment Below code on 14/10/2023 */
      /** ------------------------------------------------------------------------------------------  */

      /* Added Below code on 14/10/2023 for Allowed Extra PAYMENT amount to OPEN BALANCE  */
      const errordata = [...paymentValidation];
      errordata[index] = false;
      setPaymentValidation(errordata);
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: paymentValue,
        ["Checked"]: true,
      };
      setFormValues(updatedData);
      /* END  Comment Below code on 14/10/2023 for Allowed Extra PAYMENT amount to OPEN BALANCE  */
    }
    // else if (fieldName === "PAYMENT") {
    //   const updatedData = [...formValues];

    //   if (Number(event.target.value) > Number(updatedData[index].OPENBALANCE)) {
    //     const errordata = [...creditValidation];
    //     errordata[index] = true;
    //     // setCreditValidation(errordata);

    //     const indexOfChange = updatedData.findIndex(
    //       (el) => el?.ReceivingID == row?.ReceivingID
    //     );

    //     updatedData[indexOfChange] = {
    //       ...updatedData[indexOfChange],
    //       ["CREDITAPPLIEDVALUE"]: Number(updatedData[index].OPENBALANCE) -
    //       Number(event.target.value),
    //       ["Checked"]: true,
    //     };
    //     setFormValues(updatedData);
    //     return
    //   }

    //   if (
    //     Number(event.target.value) == 0 &&
    //     (updatedData[index]?.CREDITAPPLIEDVALUE == 0
    //       ? true
    //       : updatedData[index]?.CREDITAPPLIEDVALUE == undefined)
    //   ) {
    //     updatedData[index] = {
    //       ...updatedData[index],
    //       [fieldName]: Number(event.target.value),
    //       ["Checked"]: false,
    //       ['CREDITAPPLIEDVALUE']: Number(updatedData[index].OPENBALANCE) -
    //         Number(event.target.value),
    //     };
    //   } else {
    //     updatedData[index] = {
    //       ...updatedData[index],
    //       [fieldName]: Number(event.target.value),
    //       ["Checked"]: true,
    //       ['CREDITAPPLIEDVALUE']: Number(updatedData[index].OPENBALANCE) -
    //         Number(event.target.value),
    //     };
    //   }
    //   setFormValues(updatedData);
    //   // setPaymentInputBox(event.target.value);
    //   // setFormValues((prevValues) => ({
    //   //   ...prevValues[index],
    //   //   [fieldName]: parseInt(event.target.value),
    //   // }));
    // }
    else if (fieldName === "Checked") {
      console.log(event.target.checked, fieldName);
      const updatedData = [...formValues];
      const indexOfChange = updatedData.findIndex(
        (el) => el?.ReceivingID == row?.ReceivingID
      );

      if (event.target.checked) {
        updatedData[indexOfChange] = {
          ...updatedData[indexOfChange],
          [fieldName]: event.target.checked,
          // ["CREDITAPPLIEDVALUE"]: Number(
          //   updatedData[indexOfChange].CREDITAPPLIED
          //   ),

          // ["CREDITAPPLIED"]:0,
          ["PAYMENT"]: Number(updatedData[indexOfChange].OPENBALANCE),
        };

        // if (row.CREDITAPPLIED > 0) {
        //   if(row.OPENBALANCE >= row.CREDITAPPLIED){
        //     updatedData[indexOfChange] = {
        //       ...updatedData[indexOfChange],
        //       [fieldName]: event.target.checked,
        //       // ["CREDITAPPLIEDVALUE"]: Number(
        //       //   updatedData[indexOfChange].CREDITAPPLIED
        //       //   ),

        //         // ["CREDITAPPLIED"]:0,
        //         ["PAYMENT"]:Number(updatedData[indexOfChange].OPENBALANCE),
        //       };
        //   }else{
        //     updatedData[indexOfChange] = {
        //       ...updatedData[indexOfChange],
        //       [fieldName]: event.target.checked,
        //       ["CREDITAPPLIEDVALUE"]: Number(
        //         updatedData[indexOfChange].OPENBALANCE
        //         ),
        //         ["PAYMENT"]: 0,
        //         ["CREDITAPPLIED"]: Number(updatedData[indexOfChange].CREDITAPPLIED) - Number(
        //           updatedData[indexOfChange].OPENBALANCE
        //           ) ,
        //       };
        //     }
        // } else {
        //   updatedData[indexOfChange] = {
        //     ...updatedData[indexOfChange],
        //     [fieldName]: event.target.checked,
        //     ["CREDITAPPLIEDVALUE"]: 0,
        //     ["PAYMENT"]: Number(updatedData[indexOfChange].OPENBALANCE),
        //   };
        // }
      } else {
        updatedData[indexOfChange] = {
          ...updatedData[indexOfChange],
          [fieldName]: event.target.checked,
          ["CREDITAPPLIEDVALUE"]: 0,
          ["PAYMENT"]: 0,
          // ["CREDITAPPLIED"]:updatedData[indexOfChange].CREDITAPPLIEDVALUE
        };
        // if(row.OPENBALANCE >= row.CREDITAPPLIED){

        //   updatedData[indexOfChange] = {
        //     ...updatedData[indexOfChange],
        //     [fieldName]: event.target.checked,
        //     ["CREDITAPPLIEDVALUE"]: 0,
        //     ["PAYMENT"]: 0,
        //     ["CREDITAPPLIED"]:updatedData[indexOfChange].CREDITAPPLIEDVALUE
        //   };
        // }else{
        //   updatedData[indexOfChange] = {
        //     ...updatedData[indexOfChange],
        //     [fieldName]: event.target.checked,
        //     ["CREDITAPPLIED"]: Number(updatedData[indexOfChange].CREDITAPPLIED) + Number(
        //       updatedData[indexOfChange].CREDITAPPLIEDVALUE
        //       ),
        //       ["PAYMENT"]: 0,
        //       ["CREDITAPPLIEDVALUE"]: 0,
        //   };

        // }
      }

      setFormValues(updatedData);
    } else {
      console.log("No Condition");
    }
  };

  const handleUpdateSupplierCreditApplied = (
    supplierID,
    availableAmount,
    totalAmount,
    index
  ) => {
    console.log(supplierID, availableAmount, totalAmount, index, "837");
    const existingSupplierCreditIndex = supplierCreditAppliedValue.findIndex(
      (item) => item.supplierid === supplierID
    );

    if (existingSupplierCreditIndex !== -1) {
      const existingItem =
        supplierCreditAppliedValue[existingSupplierCreditIndex];
      existingItem.availableAmount = parseFloat(availableAmount);
      existingItem.TotalAmount = totalAmount;
      const updatedDataNew = [...supplierCreditAppliedValue];
      updatedDataNew[existingSupplierCreditIndex] = existingItem;
      setSupplierCreditAppliedValue(updatedDataNew);
    } else {
      // setSupplierCreditAppliedValue([
      //   ...supplierCreditAppliedValue,
      //   {
      //     supplierid: supplierID,
      //     availableAmount: availableAmount,
      //     TotalAmount: totalAmount,
      //   },
      // ]);

      const updatedData = [...formValues];

      updatedData[index] = {
        ...updatedData[index],
        ["AvailableAmount"]: availableAmount,
      };
      setFormValues(updatedData);

      setSupplierCreditAppliedValue([
        ...supplierCreditAppliedValue,
        {
          supplierid: supplierID,
          availableAmount: availableAmount,
          totalAmount: totalAmount,
        },
      ]);
    }
  };

  // console.log("valueisssssssss", value);

  const handleCellChange = (event, row, index) => {
    console.log(event.target.value, row, index, "handleCellChange");
    setValue(true);
    const creditValue = parseFloat(event.target.value);
    console.log("creditAppliedValue is..", creditValue);
    // const paymentValue = parseFloat(rowTotalAmount[index]?.payment) || 0;
    const paymentValueFilter = rowCreditTotalAmount.filter((e) => {
      return (
        e !== undefined &&
        e.supplierID === row.SupplierID &&
        e.receivingID == row.ReceivingID
      );
    });
    const paymentValue = parseFloat(paymentValueFilter?.payment) || 0;

    console.log("paymentValue is...", paymentValue);
    const newTotalAmount = creditValue + paymentValue;
    console.log("newTotalAmount is...", newTotalAmount);

    const updatedRowTotalAmount = [...rowCreditTotalAmount];
    updatedRowTotalAmount[index] = {
      payment: paymentValue,
      creditApplied: creditValue,
      totalAmount: newTotalAmount,
      supplierID: row.SupplierID || row?.SupplierId,
      receivingID: row.ReceivingID || row?.ReceivingId,
      isChecked: true,
    };
    setRowCreditTotalAmount(updatedRowTotalAmount);
    console.log("updatedRowTotalAmount 111==> ", updatedRowTotalAmount);
    setCreditAppliedInputBox(creditValue);

    console.log("Row Index", row);
    // Perform necessary calculations based on the event and row data...
    const newValue = event.target.value; // Get the new v
    let creditApplied = row.CREDITAPPLIED;

    // Update the creditAppliedValue state
    handleUpdateCreditApplied(
      newValue > 0 ? newValue : 0,
      row.SupplierID || row?.SupplierId,
      row.ReceivingID || row?.ReceivingId
    );
    console.log("creditAppliedValue 11 ===>", creditAppliedValue);

    let totalCount = 0;
    // let creditApplicationValueFilter = creditAppliedValue.filter(
    //   (e) => e.supplierid === row.SupplierID
    // );

    if (creditAppliedValue != undefined && creditAppliedValue != null) {
      let creditApplicationValueFilter = creditAppliedValue.filter((e) => {
        return e.supplierid === row.SupplierID;
      });
      totalCount = creditApplicationValueFilter.reduce(
        (a, v) => (a = parseFloat(a) + parseFloat(v.value)),
        0
      );
    }

    let availableAmount = parseFloat(creditApplied) - parseFloat(totalCount);

    let totalAmount = row.CREDITAPPLIED;
    handleUpdateSupplierCreditApplied(
      row?.SupplierID,
      availableAmount,
      totalAmount,
      index
    );
  };
  // useEffect(() => {
  //   setTotalAmount(parseInt(paymentInputBox) + parseInt(creditAppliedInputBox));
  // }, [paymentInputBox, creditAppliedInputBox]);

  const handleSubmit = () => {
    // console.log("chartOfAccountDropdown", chartOfAccountDropdown);
    // chartOfAccountDropdown.map((el) => {
    let pData, cab;
    if (balanceAmount !== 0) {
      // return alert("Please fill");
      // console.log("111111111111111111111");
      console.log("FormValues ==> ", formValues);
      console.log("amountReceived ==> ", amountReceived);
      console.log("Attactment ==> ", FileUrl);
      console.log("Payment Date ==> ", todayDate);
      console.log("data", data);
      if (paramObject.id > 0) {
        pData = formValues.map((el) => {
          const mappedData = {
            id: el?.ID,
            ReceivingId: el?.ReceivingId,
            SupplierIds: el?.SupplierID,
            CreditApplied: el?.CREDITAPPLIEDVALUE,
            PaymentAmount: el?.PAYMENT,
            PaymentmethodId: el?.PaymentMethod,
            RefNo: el?.RefrenceNumber,
            TotalAmount:
              parseFloat(el?.CREDITAPPLIEDVALUE ? el?.CREDITAPPLIEDVALUE : 0) +
              parseFloat(el?.PAYMENT ? el?.PAYMENT : 0),
          };
          return mappedData;
        });
      } else {
        cab = formValues.map((el) => {
          if (el?.Checked) {
            const mapped = {
              ReceivingId: el?.ReceivingID,
              SupplierIds: el?.SupplierID,
              CreditApplied: el?.CREDITAPPLIEDVALUE,
              PaymentAmount: el?.PAYMENT,
              PaymentmethodId: el?.PaymentMethod,
              RefNo: el?.RefrenceNumber,
              TotalAmount:
                parseFloat(
                  el?.CREDITAPPLIEDVALUE ? el?.CREDITAPPLIEDVALUE : 0
                ) + parseFloat(el?.PAYMENT ? el?.PAYMENT : 0),
              id: 0,
            };
            return mapped;
          }
        });
      }
      console.log("pData", pData);
      console.log("=========>>>>>>", cab);
      let PayBillsItemData = cab?.filter(function (payBillsItem) {
        return payBillsItem?.ItemId != "" && payBillsItem != null;
      });
      let PayBillsItempData = pData?.filter(function (payBillsItem) {
        return payBillsItem?.ItemId != "" && payBillsItem != null;
      });
      const payBillsItemobj = {};
      const billitemsxmlObj = {};
      billitemsxmlObj.billitemsxml =
        paramObject.id > 0 ? PayBillsItempData : PayBillsItemData;
      payBillsItemobj.billitemsxmldata = billitemsxmlObj;
      // payBillsItemobj.billitemsxmldata = PayBillsItemData;
      let paybillsjsonstring = JSON.stringify(payBillsItemobj);
      console.log("billitemsxmldata: ", paybillsjsonstring);
      // return true;
      const submitData = {
        xmlbillitems: paybillsjsonstring,
        accountid: accountId,
        paymentdate: todayDate,
        amountreceived: total,
        locationid: locationId,
        loginuserid: Id,
      };
      console.log("submit data====>>>", submitData);
      axios
        .post(
          `${config.receivingBaseUrl}/receivings/receivingpaybillupsert`,
          submitData,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("res data ==========>>>>", res);
          if (res.data.ResponseCode === "SUCCESS") {
            toastSuccess(SUCCESS_MESSAGE);

            if (paramObject.id == undefined) {
              window.location.reload();
            } else {
              navigate(-1);
            }
            // console.log("res.data.ResponseID", res.data.ResponseID);
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            // toastError("Email" + ALREADY_EXIST);
          } else {
            toastError(ERROR_MESSAGE);
          }
          // setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          // setLoading(false);
        });
    } else {
      toastWarn("Please fill all the Details");
    }
  };

  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    selectedSupplier,
    refrenceno,
    beginningDate,
    finalDate
  ) => {
    const supplierId = 0;
    // selectedSupplier && selectedSupplier.value ? selectedSupplier.value : 0;

    console.log("selectedSupplier:", selectedSupplier);

    beginningDate =
      beginningDate == undefined
        ? ""
        : beginningDate == null
        ? ""
        : beginningDate;
    finalDate =
      finalDate == undefined ? "" : finalDate == null ? "" : finalDate;

    // if (showPopupForWarning) {
    //   const answer = window.confirm(
    //     "If you leave this page, you’ll lose your selections. Tip: Since you can pay bills from just one page at a time, try filtering first. Continue anyway"
    //   );
    //   if (!answer) {
    //     console.log(answer, "answer")
    //     setSelectedSupplier(2);
    //     setShowPopupForWarning(false)
    //     return;
    //   }
    // }

    setLoading(true);
    // console.log(
    //   "selectedSupplier.value:",
    //   selectedSupplier && selectedSupplier.value
    // );

    // console.log("supplierId:", supplierId);
    paramObject.id === undefined &&
      axios
        .get(
          `${config.receivingBaseUrl}/receivings/paybill_list?pagenumber=${pagenumber}&pagesize=${pagesize}&filtertext=${filtertext}&ordercolumn=${ordercolumn}&currentorder=${currentorder}&supplierid=${selectedSupplier}&refrenceno=${refrenceno}&locationid=${locationId}&startdate=${beginningDate}&enddate=${finalDate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setRowPaymentTotalAmount([]);
          setRowCreditTotalAmount([]);

          console.log("res.data.ResponseData", res.data.ResponseData);
          // const data = res.data.ResponseData.map((el)=>{
          //   const mapped = {
          //     ReceivingId:el.ReceivingID,
          //     SupplierIds:el.supplierID,
          //     CreditApplied:el.CREDITAPPLIED,

          //   }
          // })
          setData(res.data.ResponseData);
          let newArray = res.data.ResponseData.map((obj) => {
            return { ...obj, Checked: false, PaymentMethod: 1 };
          });

          setFormValues(newArray);
          setTotalRows(res.data.ResponseData[0]?.TotalRecord);
          setLoading(false); // Set loading state to false after data is fetched
        })
        .catch((err) => {
          setLoading(false); // Set loading state to false in case of an error
        });
  };

  // const handleSupplierSelection = (selectedOption) => {
  //   // console.log("selectedSupplier is", selectedSupplier);
  //   console.log("selectedOption:>>", selectedOption);
  //   setSelectedSupplier(selectedOption.value);
  //   console.log("setSelectedSupplier===>", selectedOption.value); // Update the selected supplier
  //   // handleListData(selectedOption.value); // Call handleListData with the selected supplier
  // };

  // const handleSupplierSelection = (selectedOption) => {
  //     console.log("selectedOptionselectedOption", selectedOption.value);
  //     setSelectedSupplier(selectedOption.value); // Update the selected supplier
  // };
  console.log("selectedSupplier>>>:::::", selectedSupplier);

  const SingleRowTotal = () => {
    console.log("creditAppliedInputBox>>", creditAppliedInputBox);
    console.log("paymentInputBox>>", paymentInputBox);
    const rowTotal = creditAppliedInputBox + paymentInputBox;
    console.log("rowTotal", rowTotal);
    // return rowTotal
  };
  const filteredData = formValues.filter(
    (item) => !moment(item.DUEDATE).isSameOrAfter(moment())
  );

  console.log(filteredData, "filteredData");

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      selectedSupplier,
      refrenceno,
      beginningDate,
      finalDate
    );

    SupplierAPI();
    PaymentMethodAPI();
    CustomerAPI();
    AccountAPI();
  }, [
    perPageSize,
    searchtext,
    sortingId,
    sortingDirection,
    selectedSupplier,
    refrenceno,
  ]);

  useEffect(() => {
    if (paramObject?.id > 0) {
      axios
        .get(
          `${config.receivingBaseUrl}/receivings/paybilldetails?id=${paramObject?.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setRowPaymentTotalAmount([]);
          setRowCreditTotalAmount([]);

          console.log("get receiving paymentdata by id", res.data.ResponseData);

          setData(res.data.ResponseData);
          let newArray = res.data.ResponseData.map((obj) => {
            return {
              ...obj,
              Checked: true,
              PaymentMethod: obj.PaymentTypeId,
              CREDITAPPLIED: obj.CustomerBalance,
              OPENBALANCE: obj.OpeningBalance,
              RefrenceNumber: obj.RefNo,
              CREDITAPPLIEDVALUE: obj.CreditApplied,
              PAYMENT: parseFloat(obj.PaymentAmount).toFixed(2),
              SupplierID: obj.SupplierId,
            };
          });
          setFormValues(newArray);
          setLoading(false);
          let resData = res.data.ResponseData[0];
          setPayBillData(res.data.ResponseData);
          setBalanceAmount(resData?.Balance);
          setAccountId(resData?.AccountTypeID);
          // console.log(balanceAmount, "balanceAmount")
          // console.log(resData?.AccountTypeID, "accountId");
          // // setTodayDate(moment(resData?.PaymentDate).format("DD-MM-YYYY"))
          setTodayDate(moment(resData?.PaymentDate).format("YYYY-MM-DD"));
          // console.log(moment(res?.data?.ResponseData[0].PaymentDate).format("DD-MM-YYYY"),"1887")
          // console.log(res?.data?.ResponseData[0].PaymentDate,"1887")
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, []);

  const formData = formValues.filter((el) => el.SupplierID == selectedSupplier);
  console.log(formData, "formData1192");

  const handleClearModalPopup = () => {
    console.log("CALL POPUP EVENT");
  };

  const totals = formValues?.reduce(
    (accumulator, currentObject) => {
      accumulator.openingBalanceTotal += Number(currentObject.OPENBALANCE);
      accumulator.creditAppliedTotal += Number(
        currentObject.CREDITAPPLIEDVALUE
      );
      accumulator.paymentAmountTotal += Number(currentObject.PAYMENT);
      // accumulator.FinalTotal += Number(currentObject.Total);
      return accumulator;
    },
    {
      openingBalanceTotal: 0,
      creditAppliedTotal: 0,
      paymentAmountTotal: 0,
      FinalTotal: 0,
    }
  );

  console.log("Total 1828:", totals);
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Receiving</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li>
                <li className="breadcrumb-item active">Pay Bills</li>
              </ul>
            </div>
          </div>

          {/* Receive Payment Card */}
          <div className="card">
            <div className="card-body">
              {/* First Row */}
              <div
                className="col-md-10"
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                {/* Payment Method */}
                {/* <div className="p-2 col-md-2">
                  Account:
                  <Select
                    onChange={(event) => {
                      // handleChangeAccountSalesData(event, "AccountId")

                      console.log(
                        event?.amount == undefined ? 0 : event?.amount,
                        "amountcheck"
                      );
                      setBalanceAmount(
                        event?.amount == undefined ? 0 : event?.amount
                      );
                      setAccountId(event?.value);
                      console.log(event?.value, "accountCheck");
                    }}
                    options={accountTypeDropdownOption}
                    // value={TagsList.filter((obj) =>
                    //   selectedtags.includes(obj.value)
                    // )}
                    // value={accountId}
                    value={accountTypeDropdownOption.find(
                      (option) => option?.value == accountId
                    )}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    // isMulti={true}
                    styles={selectStyles}
                    id="AccountId"
                    name="AccountId"
                  />
                </div> */}
                {/* <div className="p-2">
                  <div className="d-flex flex-column">
                    <div className="p-1">
                      <label>Balance: </label>
                    </div>
                    <div className="p-1">
                      <span>
                        <strong>{balanceAmount}</strong>
                      </span>
                    </div>
                  </div>
                  </div> */}
                {/* <label>Balance: </label>
                                    <span><strong>{balanceAmount}</strong></span> */}
                {/* <div className="p-2 col-md-2 ms-3 ">
                  Payment Date:
                  <input
                    type="date"
                    className="form-control"
                    id="PaymentDate"
                    name="PaymentDate"
                    defaultValue={todayDate}
                    onChange={(event, index) =>
                      handleChangeInput(event, index, "PaymentDate")
                    }
                  />
                </div> */}
                <div className="col-md-4">
                  Supplier
                  <Select
                    options={supplierTypeDropdownOption}
                    value={supplierTypeDropdownOption.find(
                      (option) => option?.value == oldSelectedSupplier //selectedTerm
                    )}
                    onChange={(event) => {
                      // setSelectedSupplier(event?.value);
                      // setOldSelectedSupplier(selectedSupplier)
                      selectSupplierHandle(event?.value);
                    }} // Call the handleSupplierSelection function
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    // filterOption={customFilterOption}
                    styles={selectStyles}
                    id="Supplier"
                    name="Supplier"
                    isOptionDisabled={(option) => option.value == 0}
                    className="custom-search-select"
                    getOptionLabel={(option) =>
                      option.value === 0 ? "Select a Supplier" : option.label
                    }
                  />
                </div>
                {/* {showPopupForWarning}
                {showPopupForWarning && (
                  <div
                    className="modal fade"
                    id="ClearDataPayBill"
                    tabIndex={-1}
                    aria-labelledby="delete"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                  >
                    <div
                      className="modal-dialog modal-sm modal-dialog-centered"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Warning</h5>
                          <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="row">
                            <div className="col-lg-12 text-center">
                              <h6>
                                "If you leave this page, you’ll lose your
                                selections. Tip: Since you can pay bills from
                                just one page at a time, try filtering first.
                                Continue anyway"{" "}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                          <Link
                            to="#"
                            className="btn btn-primary btn-md me-1"
                            data-bs-dismiss="modal"
                            onClick={() => {
                              handleYes();
                            }}
                          >
                            leave
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-dark btn-md me-1"
                            data-bs-dismiss="modal"
                          >
                            Cancel{" "}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
                {/* <div className="p-2 col-md-2">
                                    Payment Method:
                                    <Select
                                        options={paymentMethodOption}
                                        placeholder="Select Payment Method"
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        hideSelectedOptions={true}
                                        isClearable={true}
                                        styles={selectStyles}
                                        id="PaymentMethod"
                                        name="PaymentMethod"
                                        onChange={(event) =>
                                            handleChangeInput(event, "PaymentMethod")
                                        }
                                    />
                                </div> */}
                <div className="col-md-2">
                  Reference Number:
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    placeholder="Reference No."
                    name="ReferenceNumber"
                    id="ReferenceNumber"
                    onChange={(event) =>
                      //   handleChangeInput(event, "ReferenceNumber")
                      setRefrenceNo(event.target.value)
                    }
                  ></input>
                </div>
                <div className=" col-md-3">
                  DueDate:
                  <Select
                    // defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleDateFilter(event);
                    }}
                    placeholder="Select Due Date"
                    options={dateOptions}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    // hideSelectedOptions={true}
                    // styles={selectStyles}
                    value={dateOptions.find((el) => el?.value == customeDate)}
                    isOptionDisabled={(option) => option.value == 0}
                    className="custom-search-select"
                  />
                </div>
                <div className="col-md-2">
                  From:
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    id="StartDate"
                    name="StartDate"
                    value={beginningDate}
                    // defaultValue={todayDate}
                    onChange={(event) => handleDate(event)}
                  />
                </div>
                <div className="col-md-2">
                  To:
                  <input
                    type="date"
                    className="form-control form-control-sm "
                    id="StartDate"
                    name="StartDate"
                    value={finalDate}
                    // defaultValue={todayDate}
                    onChange={(event) => handleEndDate(event)}
                  />
                </div>
                {/* Amount Received Display */}
                {/* <div
                  className="p-2 col-md-3 ms-auto"
                  style={{ width: "42%", textAlign: "right" }}
                >
                  <h6>TOTAL PAYMENT AMOUNT</h6>
                  <h3 className="fw-bolder">${total ? total : "0"}</h3>
                </div> */}
              </div>
            </div>
          </div>

          {/* Receive Payment Table Card */}
          <div className="card">
            <div className="card-body" style={{ padding: "8px" }}>
              <div className="card-body" style={{ padding: "8px" }}>
                {/* First Row */}
                <div className="d-flex flex-row col-md-10">
                  {/* Payment Method */}
                  <div className="p-2 col-md-4">
                    Account:
                    <Select
                      onChange={(event) => {
                        // handleChangeAccountSalesData(event, "AccountId")

                        // console.log(
                        //   event?.amount == undefined ? 0 : event?.amount,
                        //   "amountcheck"
                        // );
                        setBalanceAmount(
                          event?.amount == undefined ? 0 : event?.amount
                        );
                        setAccountId(event?.value);
                        console.log(event?.value, "accountCheck");
                      }}
                      options={accountTypeDropdownOption}
                      // value={TagsList.filter((obj) =>
                      //   selectedtags.includes(obj.value)
                      // )}
                      // value={accountId}

                      value={accountTypeDropdownOption?.find(
                        (option) => option?.value === accountId
                      )}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      // isMulti={true}
                      styles={selectStyles}
                      id="AccountId"
                      name="AccountId"
                      className="custom-search-select"
                    />
                  </div>
                  <div className="p-2">
                    <div className="d-flex flex-column">
                      <div className="p-1">
                        <label>Balance: </label>
                      </div>
                      <div className="p-1">
                        <span>
                          <strong>{balanceAmount}</strong>
                        </span>
                      </div>
                    </div>
                    {/* <label>Balance: </label>
                                    <span><strong>{balanceAmount}</strong></span> */}
                  </div>
                  <div className="p-2 col-md-2 ms-3 ">
                    Payment Date:
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="PaymentDate"
                      name="PaymentDate"
                      value={todayDate}
                      onChange={(event, index) =>
                        handleChangeInput(event, index, "PaymentDate")
                      }
                    />
                  </div>
                  <div className="p-2 col-md-2 mb-3">
                    {/* Supplier
                    <Select
                      options={supplierTypeDropdownOption}
                      value={supplierTypeDropdownOption.find(
                        (option) => option?.value == oldSelectedSupplier //selectedTerm
                      )}
                      onChange={(event) => {
                        // setSelectedSupplier(event?.value);
                        // setOldSelectedSupplier(selectedSupplier)
                        selectSupplierHandle(event?.value);
                      }} // Call the handleSupplierSelection function
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      // filterOption={customFilterOption}
                      styles={selectStyles}
                      id="Supplier"
                      name="Supplier"
                      isOptionDisabled={(option) => option.value == 0}
                    /> */}
                  </div>
                  {/* {showPopupForWarning}
                {showPopupForWarning && (
                  <div
                    className="modal fade"
                    id="ClearDataPayBill"
                    tabIndex={-1}
                    aria-labelledby="delete"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                  >
                    <div
                      className="modal-dialog modal-sm modal-dialog-centered"
                      role="document"
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Warning</h5>
                          <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <div className="row">
                            <div className="col-lg-12 text-center">
                              <h6>
                                "If you leave this page, you’ll lose your
                                selections. Tip: Since you can pay bills from
                                just one page at a time, try filtering first.
                                Continue anyway"{" "}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer justify-content-center">
                          <Link
                            to="#"
                            className="btn btn-primary btn-md me-1"
                            data-bs-dismiss="modal"
                            onClick={() => {
                              handleYes();
                            }}
                          >
                            leave
                          </Link>
                          <Link
                            to="#"
                            className="btn btn-dark btn-md me-1"
                            data-bs-dismiss="modal"
                          >
                            Cancel{" "}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
                  {/* <div className="p-2 col-md-2">
                                    Payment Method:
                                    <Select
                                        options={paymentMethodOption}
                                        placeholder="Select Payment Method"
                                        backspaceRemovesValue={false}
                                        controlShouldRenderValue={true}
                                        hideSelectedOptions={true}
                                        isClearable={true}
                                        styles={selectStyles}
                                        id="PaymentMethod"
                                        name="PaymentMethod"
                                        onChange={(event) =>
                                            handleChangeInput(event, "PaymentMethod")
                                        }
                                    />
                                </div> */}
                  {/* Amount Received Display */}
                  <div
                    className="p-2 col-md-2 ms-auto"
                    style={{ width: "42%", textAlign: "right" }}
                  >
                    <h6>TOTAL PAYMENT AMOUNT</h6>
                    {
                      // (paramObject.id > 0) ? (
                      //   <h3 className="fw-bolder">${paymentTotal ? paymentTotal : "0"}</h3>
                      // ) : (
                      <h3 className="fw-bolder">${total ? total : "0"}</h3>
                      // )
                    }
                    {paramObject.id > 0 ? (
                      ""
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          textAlign: "end",
                          fontSize: "18px",
                          // margin: "10px 10px 10px 10px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div>{formValues.length + " "}open bill</div>
                        {formValues.length > 0 && filteredData.length > 0 && (
                          <>
                            <div>
                              , {filteredData.length} overdue{" "}
                              <i
                                className="fa fa-circle"
                                style={{ color: "red" }}
                              ></i>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Outstanding Transactions Table */}
              {true && (
                <>
                  <div className="table-responsive">
                    <DataTable
                      // title="Outstanding Transactions"
                      columns={outstandingColumns}
                      data={formData.length == 0 ? formValues : formData}
                      progressPending={loading}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={(e) => {
                        handlePerRowsChange(1, e);
                      }}
                      onChangePage={handlePageChange}
                      highlightOnHover
                      striped
                      // responsive
                      paginationRowsPerPageOptions={[100, 500]}
                      paginationPerPage={rowsPerPage}
                      persistTableHead
                      // selectableRows
                      // onSelectedRowsChange={(e) => handleCheckboxChange(e)}
                      sortServer
                      onSort={handleSort}
                      // footer={footer}

                      // contextActions={contextActions}
                      // onSelectedRowsChange={handleRowSelected}
                      // clearSelectedRows={toggleCleared}
                    />
                  </div>
                </>
              )}
              {/* <div>
                                <div style={{ paddingRight: '460px' }}>
                                    <p className="pull-right">Current account balance : <span>{balanceAmount}</span></p>
                                </div>
                                <br />
                                <div style={{ paddingRight: '420px' }}>
                                    <p className="pull-right">Total payment : <span>$0.00</span></p>
                                </div>
                                <br />
                                <div style={{ paddingRight: '420px' }} >
                                    <hr style={{ width: '10%', border: 'none', borderTop: '1px solid #000' }} className="pull-right mb-2" />
                                </div>
                                <br />
                                <div >
                                    <p className="pull-right">New account balance : <span>$0.00</span></p>
                                </div>
                            </div> */}
              <div
                style={{
                  marginRight: "2rem",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "4rem",
                  alignItems: "center",
                  height: "5rem",
                }}
              >
                <div>
                  <p>
                    {" "}
                    Total OpenBalance:{" "}
                    {paramObject?.id > 0
                      ? totals?.openingBalanceTotal
                      : totalOpenBalance}
                  </p>
                </div>
                <div>
                  <p>
                    {" "}
                    Total Credit:{" "}
                    {paramObject?.id > 0
                      ? totals?.creditAppliedTotal
                      : totalCreditValue}
                  </p>
                </div>
                <div>
                  <p>
                    {" "}
                    Total Payment:{" "}
                    {paramObject?.id > 0
                      ? totals?.paymentAmountTotal
                      : totalPayment}
                  </p>
                </div>
                <div>
                  <p>
                    {" "}
                    Total Amount:{" "}
                    {paramObject?.id > 0
                      ? totals?.creditAppliedTotal + totals?.paymentAmountTotal
                      : totalCreditValue + totalPayment}
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginLeft: "2rem",
                }}
              >
                {/* <div
                className="col-md-3"
                > */}
                {paramObject.id > 0 ? (
                  ""
                ) : (
                  <p
                  // className="bold"
                  >
                    {totalChecked} bills selected
                  </p>
                )}
                {/* </div> */}
                <div
                // className="col-md-3"
                >
                  <p>
                    Total payment (USD):{" "}
                    {paramObject.id > 0 ? paymentTotal : total}
                  </p>
                </div>
                <div
                // className="col-md-3"
                >
                  {/* <p>Total payment (USD) 1,325.00</p> */}
                </div>
                {/* <div className="col-md-6">
                <div className="d-flex justify-content-around mb-2 mt-2">
                  <div>
                    <p>
                      Current account balance : <span>{balanceAmount}</span>
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-around mb-2 ms-5">
                  <div
                    style={{
                      borderBottom: "1px solid black ",
                      width: "40%",
                      textAlign: "center",
                      marginLeft: "10px",
                    }}
                  >
                    <p>
                      Total payment : <span>$0.00</span>
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-around">
                  <div
                    style={{
                      width: "40%",
                      textAlign: "center",
                      marginRight: "60px",
                    }}
                  >
                    <p className="pull-right">
                      New account balance : <span>$0.00</span>
                    </p>
                  </div>
                </div>
                </div> */}
                <div
                // style={{
                //   marginLeft: "78%",
                // }}
                // className="col-md-3"
                >
                  <div>
                    <p>
                      {" "}
                      Current account balance :{" "}
                      {/* {(paramObject.id > 0) ? (
                        <span>
                          {payBillData[0]?.Balance == undefined ? 0 : payBillData[0]?.Balance}
                        </span>

                      ) : ( */}
                      <span>
                        {balanceAmount == undefined ? 0 : balanceAmount}
                      </span>
                      {/* ) */}
                      {/* } */}
                      {/* <span>
                        {balanceAmount == undefined ? 0 : balanceAmount}
                      </span> */}
                    </p>
                  </div>
                  <div>
                    <p>
                      {/* Total payment : <span>{(paramObject.id > 0) ? (paymentTotal) : (total)}</span> */}
                      Total payment :{" "}
                      <span>
                        {paramObject?.id > 0
                          ? totals?.paymentAmountTotal
                          : totalPayment}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p>
                      New account balance :{" "}
                      {paramObject.id > 0 ? (
                        <span>
                          {balanceAmount - paymentTotal
                            ? balanceAmount - paymentTotal
                            : 0}
                        </span>
                      ) : (
                        <span>
                          {balanceAmount - total
                            ? (balanceAmount - total).toFixed(2)
                            : 0}
                        </span>
                      )}
                      {/* <span>
                        {balanceAmount - total
                          ? (balanceAmount - total).toFixed(2)
                          : 0}
                      </span> */}
                    </p>
                  </div>
                </div>
              </div>

              {/* Credits Table */}
              {/* {true && (
                                <>
                                    <div className="table-responsive">
                                        <DataTable
                                            title="Credits"
                                            columns={creditsColumns}
                                            // data={data}
                                            // progressPending={loading}
                                            pagination
                                            paginationServer
                                            // paginationTotalRows={totalRows}
                                            // paginationDefaultPage={currentPage}
                                            // onChangeRowsPerPage={(e) => {
                                            //   handlePerRowsChange(1, e);
                                            // }}
                                            // onChangePage={handlePageChange}
                                            highlightOnHover
                                            striped
                                            responsive
                                            paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                                            persistTableHead
                                            selectableRows
                                            sortServer
                                        // onSort={handleSort}
                                        // contextActions={contextActions}
                                        // onSelectedRowsChange={handleRowSelected}
                                        // clearSelectedRows={toggleCleared}
                                        />
                                    </div>
                                </>
                            )} */}

              {/* Handle Clear payment */}
              {/* {true && (
                                <>
                                    <div className="pull-right">
                                        <div>
                                            <h6 className="fw-bold">
                                                Amount to Apply:&nbsp;&nbsp;&nbsp;&nbsp; $
                                                {amountReceived}
                                            </h6>
                                            <h6 className="fw-bold">
                                                Amount to Credit:&nbsp;&nbsp;&nbsp;&nbsp; $
                                                {amountReceived}
                                            </h6>
                                            <button className="btn btn-primary">Clear Payment</button>
                                        </div>
                                    </div>
                                </>
                            )} */}

              <div className="d-flex flex-column-reverse mb-3">
                {/* <div className="p-2 col-md-3">
                                    Memo:
                                    <textarea
                                        className="form-control"
                                        name="Memo"
                                        placeholder="Note"
                                        style={{ width: "410px", height: "150px" }}
                                        onChange={(event) => handleChangeInput(event, "Memo")}
                                    ></textarea>
                                </div>
                                <div className="p-2 col-md-3">
                                    Attachment:
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="Attachment"
                                        name="Attachment"
                                        accept=".pdf,.jpg,.jpeg,.heic,.png"
                                        onChange={handleFileChange}
                                    />
                                </div> */}
              </div>
              <div className="pull-right">
                <button
                  className="btn btn-sm btn-success me-2"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                {formValues.filter((el) => el.Checked == true).length > 0 ||
                paramObject?.id > 0 ? (
                  <>
                    {/* <button className="btn btn-primary" onClick={handleSubmit}> */}
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={handleConfirmationSubmit}
                    >
                      Save & Done
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="FundModal"
        tabIndex="-1"
        // aria-labelledby="delete"
        // data-bs-backdrop="static"
        // data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          // role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmation</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6>
                    You don't have sufficient balance in your chart of accounts.
                    Do you still want to make this transaction?
                  </h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={handleSubmit}
              >
                Yes
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                No
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bill Redirection POPUP */}
      <div
        className={`modal ${showBillRedirectModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Warning</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCancelRedirect}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6>Do you want to leave without saving?</h6>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleConfirmRedirect()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancelRedirect}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* popup for filter  */}
      <div
        className={`modal ${showDateFilterModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Warning</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleDateFilterCancel}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6>Do you want to leave without saving?</h6>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleDateFilterConfirm()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDateFilterCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#ClearDataPayBill"
        ref={buttonRef}
        style={{ opacity: "0" }}
      ></button>
      <ClearDataPayBill handleYes={handleYes} />
    </>
  );
};

export default PayBills;
